import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { modules } from './schema';

Vue.use(Vuex);

let wxAct = sessionStorage.getItem('wxAccount') ? JSON.parse(sessionStorage.getItem('wxAccount')) : {};

// 快捷方式 兼容: store.dispatch
const dispatch = function (type) {
  return ({ commit }, payload = {}) => {
    commit({ type: type, ...payload });
  };
};

const store = new Vuex.Store({
  modules: modules,

  state: {
    fullScreen: true,
    loading: false,
    modal: {},
    user: JSON.parse(localStorage.getItem('user')) || {},
    wxAppId: wxAct.wxAppId || '',
    authUrl: '',
    wxAccount: wxAct,
    frontUrl: ''
  },
  mutations: {
    showModal(state, { modal }) {
      state.modal = { ...modal, show: true };
    },
    hideModal(state) {
      state.modal = { ...state.modal, show: false };
    },
    hideNav(state) {
      state.fullScreen = false;
    },
    loading(state, { loading }) {
      state.loading = loading;
    },
    userInfo(state, user) {
      state.user = user;
    },
    getAuth(state, { url }) {
      state.authUrl = url;
    },
    setFrontUrl(state, url) {
      state.frontUrl = url;
    }
  },
  actions: {
    showToast: dispatch('showToast'),
    hideToast: dispatch('hideToast'),
    tipsToast: dispatch('tipsToast'),
    showModal: dispatch('showModal'),
    hideModal: dispatch('hideModal'),
    showSheet: dispatch('showSheet'),
    hideSheet: dispatch('hideSheet'),
    hideNav: dispatch('hideNav'),
    loading: dispatch('loading'),
    menuList({ commit }, params = {}) {
      return axios.get('/home/ajax/menu', { params: params, cache: false, }, { global: false }).then((data) => {
        // commit({ type: 'menuList', menu: data.data });
        return data;
      });
    },
    getPromotionImg({ commit }, params = {}) {
      return axios.post('/account/ajax/getPromotionImg', params, { global: false }).then((data) => {
        return data;
      });
    },
    getAuth({ commit }, params = {}) {
      return axios.get('/wx/ajax/author', {
        params: {}
      }).then(data => {
        commit({ type: 'getAuth', url: data.url });
      });
    },
    getNotices({ commit }, params = {}) {
      return axios.get('/home/ajax/notificaList', { params: params, cache: true, }, { global: false }).then(data => {
        return data;
      });
    },
    readNotifica({ commit }, params = {}) {
      return axios.post('/home/ajax/readNotifica', params, { global: false }).then((data) => {
        return data;
      });
    },
    checkAccount({ commit }, params) { // 作为验证是否登录
      return axios.get('/account/ajax/checkIsLogin', {
        params: {},
        cache: true,
      }, { global: false }).then((data) => {
        return data;
      });
    },
    getNoticesDlg({ commit }, params = {}) {
      return axios.get('/home/ajax/getAlertNotices', { params: params, cache: true, }, { global: false }).then(data => {
        return data;
      });
    },
  },
});

export default store;
